import React from 'react';
import { Link } from 'react-router-dom';
import Login1 from '../components/login/Login';
import Welcome from '../components/welcome/Welcome';
import {connect} from 'react-redux';

const HomePage = ({accountId, history}) => {
  console.log('HomePage component');
  console.log('accountId', accountId);
  let accountId1 = localStorage.getItem('accountId');
  console.log('accountId1', accountId1);
  return (
    <div>
      {
        !accountId1 &&
        <Login1 />
      }
      {
        accountId1 &&
        <Welcome history={history} />
      }
    </div>
  );
};

const HomePage1 = connect((state)=>{
  return {
    accountId: state.authReducer.accountId
  }
},//state
  null)(HomePage);

export default HomePage1;


//export default HomePage;



// WEBPACK FOOTER //
// ./src/components/HomePage.js